<script>
import con from '@services/connection'
import { user, simulador } from '@constants/URL'
import Title from '@components/section-title'
import rules from '@constants/Rules'
import Vue from 'vue'
import store from '@state/store'
import { toMoney, getNumber, toPercent } from '@utils/Format'
import { GlobalBus } from '@services/bus'
import {
  MODAL,
  DIC_CLASSES_SIMULADOR,
  DIC_CLASSES_REVERSE_SIMULADOR,
  COMPR_ESTR_SIMULADOR_WITH_COLORS,
} from '@constants/Text'
import Card from '@components/card-div'

export default {
  components: {
    Title,
    Card,
  },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      simulacao: {
        restricoes: {},
        composicao_estrategica: {},
        ativos_fixos: [],
      },
      dicClasseReverse: DIC_CLASSES_REVERSE_SIMULADOR,
      dicClasse: DIC_CLASSES_SIMULADOR,
      compEstr: COMPR_ESTR_SIMULADOR_WITH_COLORS,
      modo: 'classe',
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    filteredComposicaoOpts() {
      return {
        legend: false,
        dataLabels: {
          enabled: false,
        },
        tooltip: {},
        labels: Object.keys(
          this.simulacao.restricoes.composicao_estrategica
        ).map((a) => {
          return this.dicClasseReverse[a] || a
        }),
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  fontSize: '12px',
                  fontFamily: this.$STYLES.FONT_FAMILY,
                  color: '#2D212F',
                  offsetY: -15,
                },
                value: {
                  fontSize: '12px',
                  fontFamily: this.$STYLES.FONT_FAMILY,
                  offsetY: -15,
                  formatter: (v) => {
                    return toMoney(v)
                  },
                },
                total: {
                  show: true,
                  formatter: (w) => {
                    return toMoney(
                      w.globals.seriesTotals.reduce((a, b) => {
                        return a + b
                      }, 0)
                    )
                  },
                },
              },
            },
          },
        },
      }
    },
    filteredComposicao() {
      return Object.values(this.simulacao.restricoes.composicao_estrategica)
    },
    compEstrOpts() {
      return {
        legend: false,
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          fillSeriesColor: false,
          y: {
            formatter: (v) => {
              return toPercent(v)
            },
          },
        },
        labels: Object.keys(this.compEstr),
        colors: Object.values(this.compEstr).map((a) => {
          return a.color
        }),
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  fontSize: '12px',
                  fontFamily: this.$STYLES.FONT_FAMILY,
                  color: '#2D212F',
                  offsetY: -15,
                },
                value: {
                  fontSize: '12px',
                  fontFamily: this.$STYLES.FONT_FAMILY,
                  offsetY: -15,
                  formatter: (v) => {
                    return toPercent(v)
                  },
                },
                total: {
                  show: true,
                  formatter: (w) => {
                    return toPercent(
                      w.globals.seriesTotals.reduce((a, b) => {
                        return getNumber(a) + getNumber(b)
                      }, 0)
                    )
                  },
                },
              },
            },
          },
        },
      }
    },
    compEstrData() {
      const list = Object.values(this.compEstr).map((v) => {
        return getNumber(v.percent * 100)
      })
      return list
    },
    isManual() {
      return this.simulacao.restricoes.tipo_simulador === 'manual'
    },
  },
  created() {
    GlobalBus.$on(MODAL.VER_RESTRICOES, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.VER_RESTRICOES, this.open)
  },
  methods: {
    toMoney(d) {
      return toMoney(d)
    },
    toPercent(d) {
      return toPercent(d)
    },
    open(simulacao) {
      this.simulacao = simulacao
      this.modo = simulacao.modo_simulador || 'classe'

      Object.values(this.compEstr).forEach((a) => {
        a.percent = 0
      })

      this._load()
      this.busModal.$emit('dialog', true)
    },
    async _load() {
      if (this.loading) {
        return
      }

      this.loading = true

      const r = await con.get(
        simulador.manage +
          this.simulacao.hash_code +
          '?attributes=restricoes_simulacao,id_cliente_app'
      )

      if (r.status === 200) {
        this.simulacao.restricoes = r.value.restricoes_simulacao
        Object.entries(
          r.value.restricoes_simulacao.composicao_estrategica
        ).forEach((c) => {
          console.log(c[0])
          if (
            this.dicClasseReverse[c[0]] &&
            this.compEstr[this.dicClasseReverse[c[0]]]
          ) {
            this.compEstr[this.dicClasseReverse[c[0]]].percent = c[1]
          }
        })
      } else {
        this.simulacao.restricoes = {}
      }

      this.loading = false
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="900">
    <Title
      title="Restrições da simulação"
      :subtitle="simulacao.nome_simulacao || ''"
    />

    <div v-if="!loading && simulacao.hash_code" style="min-height: 300px">
      <h2 class="subhead text-normal"> RESTRIÇÕES BÁSICAS </h2>
      <Card>
        <div class="row">
          <div v-if="simulacao.restricoes.pl" class="col-3">
            <v-text-field
              label="P/L simulação"
              :value="toMoney(simulacao.restricoes.pl)"
              readonly
            />
          </div>
          <div v-if="simulacao.restricoes.perfil" class="col-3">
            <v-text-field
              label="Perfil"
              :value="simulacao.restricoes.perfil"
              readonly
            />
          </div>
          <div v-if="simulacao.restricoes.janela_tempo" class="col-3">
            <v-text-field
              label="Janela de tempo"
              suffix="meses"
              :value="simulacao.restricoes.janela_tempo"
              readonly
            />
          </div>
          <div v-if="!isManual" class="col-3">
            <v-radio-group
              dense
              hide-details
              label="Tipos de ativos"
              :value="simulacao.restricoes.tipo_ativos"
            >
              <v-radio value="fundos" label="Apenas fundos" />
              <v-radio value="all" label="Todos" />
            </v-radio-group>
          </div>
          <div v-if="simulacao.restricoes.min_retorno" class="col-3">
            <v-currency-field
              label="Retorno Relativo mín. (μ)"
              hide-details
              :value="simulacao.restricoes.min_retorno"
              suffix=" %"
            />
          </div>
          <div v-if="simulacao.restricoes.min_risco" class="col-3">
            <v-currency-field
              label="Volatilidade máx. (σ)"
              hide-details
              :value="simulacao.restricoes.min_risco"
              suffix=" %"
            />
          </div>
          <div v-if="simulacao.restricoes.qtd_min" class="col-3">
            <v-text-field
              label="Minimo de ativos"
              :value="simulacao.restricoes.qtd_min"
              readonly
            />
          </div>
          <div v-if="simulacao.restricoes.qtd_max" class="col-3">
            <v-text-field
              label="Maximo de ativos"
              :value="simulacao.restricoes.qtd_max"
              readonly
            />
          </div>
        </div>
      </Card>
      <div
        v-if="
          simulacao.restricoes &&
            simulacao.restricoes.tipo_simulador !== 'manual'
        "
      >
        <v-divider class="mt-10 mb-10" />
        <h2 class="subhead text-normal"> COMPOSIÇÃO ESTRATÉGICA </h2>
        <Card>
          <div class="row">
            <!-- Composição estratégica -->
            <div class="col-6">
              <div v-for="c in Object.values(compEstr)" class="row mt-1">
                <div class="col-5 text-right">
                  <small> {{ c.name }} </small>
                  <br />
                  <small
                    v-if="simulacao.restricoes.fgc[dicClasse[c.name]]"
                    class="text-secondary"
                  >
                    Somente FGC
                  </small>
                </div>
                <div
                  :style="{
                    width: '3px',
                    'background-color': c.color,
                    'border-radius': '30px',
                  }"
                >
                </div>
                <div class="col-4 py-0 d-flex align-items-center">
                  <v-text-field
                    label="Valor"
                    :value="
                      isManual
                        ? toPercent(c.percent)
                        : toPercent(c.percent * 100)
                    "
                    readonly
                    dense
                    hide-details
                  />
                </div>
              </div>
            </div>
            <div class="col-6">
              <div
                class="d-flex justify-content-center align-items-center"
                style="height: 100%;"
              >
                <apexchart
                  type="donut"
                  height="400"
                  width="400"
                  :options="compEstrOpts"
                  :series="compEstrData"
                >
                </apexchart>
              </div>
            </div>
          </div>
        </Card>
      </div>
      <v-divider
        v-if="
          simulacao.restricoes.ativos_fixos &&
            simulacao.restricoes.ativos_fixos.length
        "
        class="mt-10 mb-10"
      />
      <h2
        v-if="
          simulacao.restricoes.ativos_fixos &&
            simulacao.restricoes.ativos_fixos.length
        "
        class="subhead text-normal"
      >
        ATIVOS FIXADOS
      </h2>
      <Card
        v-if="
          simulacao.restricoes.ativos_fixos &&
            simulacao.restricoes.ativos_fixos.length
        "
      >
        <div class="row">
          <!-- ATIVOS -->
          <div class="col-12">
            <v-simple-table fixed-header height="400">
              <template v-slot>
                <thead>
                  <tr>
                    <th class="text-left">Ativos fixados</th>
                    <th class="text-left" style="min-width: 150px;">Classe</th>
                    <th
                      v-if="modo === 'subclasse'"
                      class="text-left"
                      style="min-width: 150px;"
                    >
                      Subclasse
                    </th>
                    <th class="text-left" style="min-width: 150px;">
                      P/L fixado
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="ativo in simulacao.restricoes.ativos_fixos">
                    <td>{{ ativo.nome_ativo }}</td>
                    <td>{{ ativo.classe }}</td>
                    <td v-if="modo === 'subclasse'">{{ ativo.subclasse }}</td>
                    <td>{{ toMoney(ativo.pl) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </Card>
    </div>
    <v-row
      v-if="loading"
      justify="center"
      align="center"
      style="min-height: 300px"
    >
      <div class="text-center ma-12 w-100 v-application">
        <v-progress-circular
          :size="50"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </v-row>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close">
        Voltar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


